import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: {
    ...mapGetters(['account']),
  },
})
export default class PerfilNavbarSkeleton extends Vue {}
